(function () {
"use strict";

var $784b370a01333b6a$var$_style = $784b370a01333b6a$var$_interopRequireDefault({});
function $784b370a01333b6a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $784b370a01333b6a$var$mobileAdjust() {
    var hero = document.querySelector('.hero');
    if (window.innerWidth < 768) {
        var navHeight = document.querySelector('.nav').clientHeight;
        hero.style.marginTop = navHeight * -1 + 'px';
    } else hero.style.marginTop = 0;
}
document.addEventListener('DOMContentLoaded', function() {
    var navLinks = document.querySelectorAll('.nav__link');
    navLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            var target = event.target;
            var href = target.href;
            var i = href.indexOf('#');
            var dest = document.getElementById(href.substr(i + 1));
            var scroll = dest.getBoundingClientRect().top + window.pageYOffset;
            console.log(dest, scroll);
            window.scroll({
                top: scroll,
                behavior: 'smooth'
            });
        });
    });
    var photos = document.querySelectorAll('.photo');
    photos.forEach(function(photo) {
        var mainPhoto = photo.querySelector('.photo__main .photo__image');
        var thumbPhotos = photo.querySelectorAll('.photo__thumb .photo__frame');
        thumbPhotos.forEach(function(thumbPhoto) {
            var changeImage = function changeImage(event) {
                var target = event.target;
                var img = target.children[0] || target;
                mainPhoto.src = img.src;
            };
            if (window.ontouchstart === undefined) thumbPhoto.addEventListener('mouseenter', changeImage);
            else thumbPhoto.addEventListener('touchend', changeImage);
        });
    });
    var heroTitle = document.querySelector('.hero__title');
    heroTitle.style.opacity = 0;
    var heroMessage = document.querySelector('.hero__message');
    heroMessage.style.opacity = 0;
    $784b370a01333b6a$var$mobileAdjust();
});
document.addEventListener('resize', function() {
    $784b370a01333b6a$var$mobileAdjust();
});
document.addEventListener('scroll', function() {
    var hero = document.querySelector('.hero');
    var heroTop = hero.getBoundingClientRect().top;
    if (heroTop <= 0) hero.classList.add('hero--fadeIn');
    var works = document.querySelectorAll('.work');
    works.forEach(function(work) {
        var items = work.querySelectorAll('.work__item');
        items.forEach(function(item) {
            var windowHeight = window.innerHeight;
            var posTop = item.getBoundingClientRect().top;
            var height = item.clientHeight / 2;
            if (windowHeight - posTop > height) item.classList.add('work__item--fadeIn');
            else if (windowHeight - posTop <= 0) item.classList.remove('work__item--fadeIn');
        });
    });
});

})();
//# sourceMappingURL=portfolio.08efde42.js.map
